import { Button, Notification } from '@schibsted-svp/react-ui';
import { IMAGE_TYPES } from 'components/AssetForm/types';
import { Dropzone } from 'components/video/Dropzone/Dropzone';
import validate from 'components/video/VideoPoster/PosterUploader.validator';
import { reportMessage } from 'lib/error';
import * as PropTypes from 'prop-types';
import { MdAdd } from 'react-icons/md';
import { THEME_IMAGE_TYPES } from 'screens/NewsroomScreen/PlaylistsScreen/types';
import css from './PosterPlaceholder.module.scss';

function PosterPlaceholder({ handlePosterChange, onVideoPosterUpload, type, minimumSize, maximumSize }) {
    const handlePosterDnD = async (files) => {
        try {
            const result = await validate(Array.from(files), {
                minWidth: minimumSize[0],
                minHeight: minimumSize[1],
                maxWidth: maximumSize[0],
                maxHeight: maximumSize[1],
            });
            if (result.isValid) {
                onVideoPosterUpload(result.file, type);
            } else {
                Notification.notify.error(result.message);
            }
        } catch (error) {
            const message =
                'Something went wrong during upload. Please contact us on Slack or on mail:svp@schibsted.com';

            reportMessage({
                message,
                error,
            });
            Notification.notify.error(message);
        }
    };

    return (
        <Dropzone onUpload={handlePosterDnD} className={css.dropzone}>
            {() => (
                <Button type="label" size="small" iconOnly>
                    <input id="uploadInput" type="file" accept="image/*" onChange={handlePosterChange} hidden />
                    <MdAdd size={20} />
                </Button>
            )}
        </Dropzone>
    );
}

PosterPlaceholder.propTypes = {
    handlePosterChange: PropTypes.func.isRequired,
    onVideoPosterUpload: PropTypes.func.isRequired,
    minimumSize: PropTypes.arrayOf(PropTypes.number).isRequired,
    maximumSize: PropTypes.arrayOf(PropTypes.number).isRequired,
    type: PropTypes.oneOf([...IMAGE_TYPES, ...THEME_IMAGE_TYPES]).isRequired,
};

export default PosterPlaceholder;
